<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->


<template>
  <div class="wy-analytics-contact-reasons-detail-topic-relations">
    <div class="topic-group-section">
      <div class="div-group-viewer-header div-group-name">
        <div class="div-dispaly-name">Related Topics</div>
        <div class="div-total">% Total</div>
      </div>
      <div class="div-group-viewer-content" v-loading="loading">
        <div class="div-group-topics">
          <div class="div-topic-content">
            <div class="div-item" :title="item.topicDisplayName" v-for="(item, index) in relatedTopics" :key="index"
              v-bind:class="{ selected: (selectedTopic && selectedTopic.topicDisplayName == item.topicDisplayName) }"
              @click="getMessagesByTopics(item, 0, $event)"
              @mouseover="handlePopoverOver($event, 'Total conversations: ' + item.totalConversationsDMValue, index)"
              @mouseout="handlePopoverOut($event)">
              <div class="div-ellipsis-item">{{ item.topicDisplayName }}</div>
              <span :ref="'itemValue' + index">{{ (item.totalConversations /
                relatedTopics.totalConversationsOfAllRelatedTopics * 100).toFixed(1) }}%</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <el-popover ref="tablePopover" placement="right" title="" trigger="hover" popper-class="wy-table-change-popover"
      :content="tablePopoverContent">
    </el-popover>

    <div v-if="showMessageContent" class="topic-messages-section">
      <div class="div-topic-messages-viewer-header">Conversations</div>
      <div class="div-topic-messages-viewer-content" v-loading="loadingMsg">
        <div ref="conversationMessages" class="div-topic-message-name" v-for="(item, index) in topicMessages" :key="index"
          v-bind:class="{ selected: (selectedMessage && selectedMessage.conversationId == item.conversationId) }"
          @click="getTranscriptById(item, $event)">
          <div class="message-date">{{ formatMessageHeaderDate(item.date) }}</div>
          <div class="message-right">
            <div class="message-date-time">
              {{ getTimeRange(item) }}
            </div>
          </div>
        </div>
      </div>
      <div class="div-group-viewer-footer div-group-name">
        <div class="div-message-transcripts-viewer-footer">
          <div class="div-transcript-page-infor">Showing {{ pageItemStart }}-{{ pageItemEnd }}</div>
          <div class="div-transcript-pagination">
            <el-pagination :page-size="pageSize" :page-count="pageCount" :current-page="pageNo" :disabled="loadingMsg" prev-text="< Previous"
              next-text="Next >" @current-change="pageChanged" layout="prev, next">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>

    <wy-analytics-transcript-viewer v-if="(selectedMessage && topicMessages && topicMessages.length > 0) || loadingMsg"
      :parent="module" :messagesTranscripts="topicMessagesTranscripts" :selectedMessage="selectedMessage"
      :loading="loadingMsg || loadingTranscriptMsg" viewName="Related Topics" />

  </div>
</template>

<script>
import Vue from 'vue';
import { mapGetters, mapActions, mapMutations } from 'vuex';
import WyUtils from '../../library/wy-utils.js';
import WyAnalyticsTranscriptViewer from './wy-analytics-transcript-viewer.vue';


export default Vue.extend({
  name: 'wy-analytics-contact-reasons-detail-topic-relations',
  props: ['parent', 'activeTab'],
  components: {
    'wy-analytics-transcript-viewer': WyAnalyticsTranscriptViewer
  },

  data() {
    return {
      module: this,
      loading: false,
      loadingMsg: false,
      loadingTranscriptMsg: false,
      initDate: null,
      topicData: {},
      relatedTopics: [],
      topicMessages: [],
      topicMessagesTranscripts: [],
      showMessageContent: false,
      showTranscriptContent: false,
      selectedTopic: null,
      selectedMessage: null,
      tablePopoverContent: null,

      descSoring: true,

      pageNo: 1,
      pageSize: 100,
      pageCount: 1,
      pageItemStart: 0,
      pageItemEnd: 0,

      fetchData: true
    }
  },

  computed: {
    ...mapGetters(['dataModel', 'transcriptInfoReference']),
  },

  methods: {
    ...mapActions(['fetchContactReasonsTopicConversations', 'fetchContactReasonsTopicConversationDetail', 'fetchContactReasonsTopicRelations']),
    ...mapMutations(['updateTranscriptInfoReference']), //handle transcript info

    handleTranscriptPopover() {
      if (this.transcriptInfoReference) {
        this.transcriptInfoReference.visible = false;
        this.updateTranscriptInfoReference(null);
      }
    },

    pageChanged(pageNo) {
      this.getMessagesByTopics(this.selectedTopic, pageNo);
    },
    handleTimeInNiceFormat(Millis) {
      let seconds = Millis / 1000;

      return WyUtils.toNiceTimeFormat(seconds);
    },
    startLoading() {
      this.initDate = new Date();
      if (!this.loading) {
        this.logEventLoaded();
      }
      this.loadTopicRelations();
    },

    doSorting(isDesc) {
      if (isDesc) {
        this.relatedTopics.sort(function (a, b) {
          return parseInt(a.total) - parseInt(b.total);
        })
        this.descSoring = false;
      }
      else {
        this.relatedTopics.sort(function (a, b) {
          return parseInt(b.total) - parseInt(a.total);
        })
        this.descSoring = true;
      }
    },

    doSortingByPercentage(totalConversationsOfAllRelatedTopics, isDesc) {
      if (isDesc) {
        this.relatedTopics.sort(function (a, b) {
          let perCentageA = (a.totalConversations / totalConversationsOfAllRelatedTopics * 100).toFixed(1);
          let perCentageB = (b.totalConversations / totalConversationsOfAllRelatedTopics * 100).toFixed(1);
          return perCentageB - perCentageA;
        })
      }
      else {
        this.relatedTopics.sort(function (a, b) {
          let perCentageA = (a.totalConversations / totalConversationsOfAllRelatedTopics * 100).toFixed(1);
          let perCentageB = (b.totalConversations / totalConversationsOfAllRelatedTopics * 100).toFixed(1);
          return perCentageA - perCentageB;
        })
      }
    },

    logEventLoaded() {
      if (this.initDate) {
        this.$store.dispatch('amplitudeLogWithFilters', { name: 'subtopics_loaded', data: { topic_name: this.topicData.topicDisplayName, data_load_time: WyUtils.getTimeDiff(this.initDate) } });
        this.initDate = null;
      }
    },

    toTranscriptLabel(val) {
      return WyUtils.toTranscriptLabel(val);
    },

    formatMessageDate(date) {
      return WyUtils.formatDate(date);
    },

    formatMessageHeaderDate(date) {
      return WyUtils.formatDateWithDay(date);
    },

    getTimeRange(transcript) {
      if(transcript.msgTime) {
        return transcript.msgTime
      }
      else {
        // TODO: This is for V2 API and can be removed later 
        return WyUtils.getTimeRange(transcript);
      }
    },

    async getMessagesByTopics(item, pageNo) {
      if (pageNo) {
        this.pageNo = pageNo;
      }
      else {
        this.pageNo = 1;
        this.pageItemStart = 0;
        this.pageItemEnd = 0;
        this.pageCount = 1;
      }
      this.selectedTopic = item;
      this.showMessageContent = true;
      this.topicMessages = [];
      this.showTranscriptContent = false;
      this.loadingMsg = true;

      if (this.topicData) {
        this.topicDisplayName = this.topicData.topicDisplayName;
      }

      let result = await this.fetchContactReasonsTopicConversations({ from: 'relatedTopics', topics: item.mergedTopics, topicDisplayName: this.topicData.topicDisplayName, pageNo: this.pageNo, pageSize: this.pageSize + 1 })

      if (result.data && result.data.length > 0) {
        await this.getTranscriptById(result.data[0]);

        if (result.data.length > this.pageSize) {
          this.topicMessages = result.data.slice(0, result.data.length - 1);
          this.pageItemStart = (this.pageNo - 1) * this.pageSize + 1;
          this.pageItemEnd = this.pageItemStart + this.pageSize - 1;
          this.pageCount = this.pageNo + 1;
        }
        else {
          this.topicMessages = result.data;
          this.pageItemStart = (this.pageNo - 1) * this.pageSize + 1;
          this.pageItemEnd = this.pageItemStart + result.data.length - 1;
        }
        //this.selectedMessage = this.topicMessages[0];
        //this.topicMessagesTranscripts = this.selectedMessage.messages;
        this.showTranscriptContent = true;
      }
      else {
        this.showTranscriptContent = false;
        this.topicMessages = [];
        this.topicMessagesTranscripts = [];
        this.pageNo = 1;
        this.pageItemStart = 0;
        this.pageItemEnd = 0;
      }
      this.loadingMsg = false;
    },

    // Conversations
    async getTranscriptById(item) {
      this.loadingTranscriptMsg = true;

      let resultDetail = await this.fetchContactReasonsTopicConversationDetail({ conversationId: item.conversationId })
      if(resultDetail && resultDetail.data) {
        this.selectedMessage = resultDetail.data;
        this.topicMessagesTranscripts = this.selectedMessage.messages;
      }
      this.loadingTranscriptMsg = false;
    },

    async loadTopicRelations() {
      if (this.fetchData && this.parent.currentItem) {
        this.fetchData = false;
        this.topicData = this.parent.currentItem;
        this.loading = true;
        this.showMessageContent = false;
        this.topicMessages = [];
        let result = await this.fetchContactReasonsTopicRelations({ topics: this.topicData.mergedTopics, topicDisplayName: this.topicData.topicDisplayName });
        if (result.data && result.data.length > 0) {
          this.relatedTopics = result.data;
          this.relatedTopics.totalVolume = this.relatedTopics.reduce((accum, item) => {
            item.totalConversationsDMValue = item.totalConversations * this.$store.getters.xnumber;
            return accum + item.total
          }
            , 0);
          this.relatedTopics.totalConversationsOfAllRelatedTopics = this.relatedTopics.reduce((accum, item) => {
            return accum + item.totalConversations
          }
            , 0);
          this.doSortingByPercentage(this.relatedTopics.totalConversationsOfAllRelatedTopics, true)
          this.getMessagesByTopics(result.data[0], 0);
        }
        this.loading = false;
      }
      this.parent.stopLoadingByTab('topicRelations');
    },

    handlePopoverOver(e, content, idx) {
      if(this.$refs.tablePopover) {
        this.$refs.tablePopover.doClose();
        this.tablePopoverContent = content;
        this.$refs.tablePopover.referenceElm = this.$refs['itemValue' + idx][0]; // place it at the '% Total' (not sure why need [0])
        setTimeout(() => {
          if (this.$refs.tablePopover.referenceElm)
            this.$refs.tablePopover.doShow();
          else
            this.$refs.tablePopover.doClose();
        }, 300)
      }
    },

    handlePopoverOut() {
      if(this.$refs.tablePopover) {
        this.$refs.tablePopover.referenceElm = null;
        this.$refs.tablePopover.doClose();
      }
    },
  },

  // created() {
  //   this.loadTopicRelations();
  // },
  mounted() {
    // on resize window, we close the transcript popover
    window.addEventListener('resize', this.handleTranscriptPopover);
    // Outside of metric-analysis
    document.addEventListener('click', () => {
      this.handleTranscriptPopover();
    });
    // Inside metric-analysis
    document.querySelector('.wy-analytics-contact-reasons-detail-topic-relations').addEventListener('click', () => {
      this.handleTranscriptPopover();
    });
  }
});
</script>

<style lang="scss">
.wy-analytics-contact-reasons-detail-topic-relations {
  display: inline-flex;
  width: 100%;
  height: calc(100vh - 287px);
  // min-width: 1093px;
  min-width: 1273px;

  .transcripts-viewer-header-right {
    overflow-y: auto;
    height: 204px !important;
    padding-right: 20px;

    &::-webkit-scrollbar {
      background-color: #000 !important;
      width: 8px !important;
    }

    &::-webkit-scrollbar-thumb {
      background: #C8C8C8 !important;
      border-radius: 5px;
    }
  }

  .contact-reason-transcript-tab-info-pop-over {
    padding: 12px 7px 10px 15px !important;
  }

  .sentiment-icon-positive {
    cursor: pointer;
    background-image: url('../../assets/icons/icon_positive_senti.svg');
    background-size: 80%;
    background-repeat: no-repeat;
    background-position-y: 3px;
    background-position-x: 5px;
    position: relative;
    right: 67px;
    bottom: 8.5px;
    border-radius: 100px;
    border: 0px;
    margin: 6px 13px 0 0;
    padding: 12px 10px 14px 14px;
    float: right;
  }

  .sentiment-icon-neutral {
    cursor: pointer;
    background-image: url('../../assets/icons/icon_neutral_senti.svg');
    background-size: 80%;
    background-repeat: no-repeat;
    background-position-y: 3px;
    background-position-x: 5px;
    position: relative;
    right: 67px;
    bottom: 8.5px;
    border-radius: 100px;
    border: 0px;
    margin: 6px 13px 0 0;
    padding: 12px 10px 14px 14px;
    float: right;
  }

  .sentiment-icon-negative {
    cursor: pointer;
    background-image: url('../../assets/icons/icon_negative_senti.svg');
    background-size: 80%;
    background-repeat: no-repeat;
    background-position-y: 3px;
    background-position-x: 5px;
    position: relative;
    right: 67px;
    bottom: 8.5px;
    border-radius: 100px;
    border: 0px;
    margin: 6px 13px 0 0;
    padding: 12px 10px 14px 14px;
    float: right;
  }

  .contact-reason-group-topics-tab-info-pop-over {
    background: black;
    color: #FFFFFF;
    border: black !important;
    font-size: 14px;
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  }

  .topic-group-section {
    min-width: 404px;
    width: 404px;
    max-width: 404px;
    margin-right: 15px;
    margin-bottom: 20px;
    padding: 10px 0px 0px 0px;
    background: #FFFFFF 0% 0% no-repeat padding-box;
    border: 1px solid #E8E8E8;
    border-radius: 10px;
    opacity: 1;

    .div-group-viewer-content {
      margin-top: 10px;
      border-top: 1px solid #E8E8E8;
      height: calc(100vh - 356px);
      overflow-y: auto;
      overflow-x: hidden;
      margin-bottom: 12px;
    }

    .div-group-viewer-header.div-group-name {
      font-size: 16px;
      font-weight: 500;
      padding: 0px 0px 4px 30px;

      .div-dispaly-name {
        display: inline-block;
        width: 282px;
      }

      .div-total {
        display: inline-block;
        margin-right: 0px;
      }

      .div-sorting {
        height: 12px;
        width: 6px;
        background-repeat: no-repeat;
        display: inline-block;
        padding: 0 3px;
        cursor: pointer;
      }

      .div-sorting.asc {
        background-image: url('../../assets/icons/icon_sort_asc_black.svg');
      }

      .div-sorting.desc {
        background-image: url('../../assets/icons/icon_sort_des_black.svg');
      }
    }

    .div-group-topics {
      margin-top: 0px;

      .div-topic-content {
        height: fit-content;
        //padding-top: 10px;

        .div-item {
          color: var(--site-font-primary-color);
          font-weight: normal;
          margin: 0px 0px 0px 0px;
          line-height: 19px;
          padding: 9px 28px 7px 30px;
          font-size: 12px;
          line-height: 11px;
          // width: 88%;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          cursor: pointer;

          .div-ellipsis-item {
            width: 84%;
            display: inline-block;
            white-space: nowrap;
            overflow: hidden;
            line-height: 1.2;
            text-overflow: ellipsis;
            padding-right: 5px;
          }

          span {
            vertical-align: 3px;
            // float: right;
            margin-right: auto;
            //margin-right: 15px;
            max-width: 54px;
            width: 36px;
            min-width: 36px;
            text-align: center;
          }
        }

        .div-item:hover {
          background: #f5f7fa;
        }

        .div-item.selected {
          background: #E2ECF7;
        }
      }
    }
  }

  .topic-messages-section {
    min-width: 300px;
    width: 300px;
    padding: 7px 0px 0px 0px;
    margin-bottom: 20px;
    background: #FFFFFF 0% 0% no-repeat padding-box;
    border: 1px solid #E8E8E8;
    border-radius: 10px 0px 0px 10px;
    opacity: 1;

    .el-loading-mask {
      height: unset !important;
      opacity: unset;
      background-color: unset;

      .el-loading-spinner {
        top: 35%;
        background: var(--site-loading-icon);
        background-repeat: no-repeat;
        background-size: 25px;
        background-position: center;
      }

      .el-loading-spinner .circular {
        display: unset !important;
      }
    }

    .div-topic-messages-viewer-header {
      font-size: 16px;
      font-weight: 500;
      padding: 4px 10px 8px 30px;
    }

    .div-topic-messages-viewer-content {
      margin-top: 5px;
      border-top: 1px solid #E8E8E8;
      border-bottom: 1px solid #E8E8E8;
      height: calc(100vh - 382px);
      overflow-y: auto;
      overflow-x: hidden;
      margin-bottom: 5px;
      //padding-top: 10px;

      .div-topic-message-name {
        font-size: 12px;
        word-break: keep-all;
        cursor: pointer;
        color: var(--site-font-primary-color);
        min-width: 250px;
        font-weight: normal;
        margin: 0px 0px 0px 0px;
        line-height: 19px;
        padding: 9px 28px 7px 30px;

        .message-date {
          width: 105px;
          display: inline-block;
        }

        .message-right {
          float: right;
          width: 130px;

          .message-date-time {
            text-align: left;
            padding-right: 10px;
          }
        }
      }

      .div-topic-message-name:hover {
        background: #f5f7fa;
      }

      .div-topic-message-name.selected {
        background: #E2ECF7;
      }
    }
  }
  .message-transcripts-section {
    padding: 7px 0px 0px 0px;
    margin-bottom: 20px;
    .div-message-transcripts-viewer-content {
      padding-bottom: 0px;
    }
  }

  .div-group-viewer-footer.div-group-name {
    font-size: 16px;
    font-weight: 500;
    padding: 0px 0px 0px 0px;
  }

  .div-message-transcripts-viewer-footer {
    display: inline-block;
    width: 100%;

    .div-transcript-page-infor {
      float: left;
      padding-top: 2px;
      padding-left: 14px;
      font-size: 12px;
      color: #ADADAD;
    }

    .div-transcript-pagination {
      float: right;
      padding-right: 14px;
      font-size: 12px;
      color: #ADADAD;

      .el-pagination {
        padding-right: 0px;
      }

      .el-pagination button {
        color: #002852;
        font-weight: bold;
        padding-right: 0px;
        padding-left: 30px;
        font-size: 12px;
        line-height: unset !important;
        height: unset !important;

        >span {
          line-height: unset !important;
          height: unset !important;
        }
      }

      .el-pagination button.btn-next {
        padding-left: 10px;
      }

      .el-pagination button:disabled {
        color: #C0C4CC;
      }

      .el-pagination span:not([class*=suffix]) {
        word-spacing: 7px;
      }
    }
  }
}

.contact-reason-group-topics-tab-info-pop-over {
  font-size: 13px;
  width: fit-content !important;
  padding: 12px 7px 10px 15px;
  box-shadow: 0px 0px 20px #0000002E;
  border-radius: 10px;
  color: #E4E8EC;
  line-height: 18px;

  .popper__arrow {
    display: block !important;

    &:after {
      display: block !important;
      border-bottom-color: #000 !important;
    }
  }

  .popper-item {
    margin-bottom: 15px;
  }
}

.el-popover {
  font-size: 12px;
}
</style>